import React from 'react';
import PropTypes from 'prop-types';

const Divider = () => (
  <div className="vads-u-margin-y--6 vads-u-border--1px vads-u-border-color--gray-light" />
);

const ClaimFilesLayout = ({
  header,
  uploadForm,
  inProgress,
  filesReceived,
  filesWeCouldntReceive,
  otherWays,
}) => (
  <div className="claim-files">
    {header}
    {uploadForm}
    {inProgress && (
      <>
        <Divider />
        {inProgress}
      </>
    )}
    <Divider />
    {filesReceived}
    <Divider />
    {filesWeCouldntReceive}
    {otherWays}
  </div>
);

ClaimFilesLayout.propTypes = {
  filesReceived: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  otherWays: PropTypes.node.isRequired,
  uploadForm: PropTypes.node.isRequired,
  filesWeCouldntReceive: PropTypes.node,
  inProgress: PropTypes.node,
};

export default ClaimFilesLayout;
